<template>
  <div class="GameInfo">
    <div class="game_Progress_box" v-if="baseInfo && !baseInfo.onlineVersion">
      <div class="game_Progress">
        <div class="game_Progress_wid" v-if="baseInfo.state == -1"></div>
        <div class="game_Progress_wid2" v-if="baseInfo.state == 0"></div>
        <div class="game_Progress_wid3" v-if="baseInfo.state == 3"></div>
      </div>
      <div
        class="game_Progress_centent"
        :class="baseInfo.state >= -2 ? 'game_Progress_sum_active' : ''"
      >
        <div class="game_Progress_sum">1</div>
        <div class="game_Progress_text">{{ $t("gameinfo.creategame") }}</div>
      </div>
      <div
        class="game_Progress_centent"
        :class="baseInfo.state >= -1 ? 'game_Progress_sum_active' : ''"
      >
        <div class="game_Progress_sum">2</div>
        <div class="game_Progress_text">{{ $t("gameinfo.complete") }}</div>
      </div>
      <div
        class="game_Progress_centent"
        :class="baseInfo.state >= 0 ? 'game_Progress_sum_active' : ''"
      >
        <div class="game_Progress_sum">3</div>
        <div class="game_Progress_text">{{ $t("gameinfo.send") }}</div>
      </div>
      <div
        class="game_Progress_centent"
        :class="baseInfo.state == 3 ? 'game_Progress_sum_active' : ''"
      >
        <div class="game_Progress_sum">4</div>
        <div class="game_Progress_text">{{ $t("gameinfo.publish") }}</div>
      </div>
    </div>

    <div class="info_box">
      <div class="nav">
        <div>
          <div>
            <a-menu
              mode="inline"
              :default-selected-keys="[selectedkeys]"
              :default-open-keys="['sub1']"
            >
              <router-link
                tag="span"
                :to="{
                  path: item.path,
                  query: { appId: appId, gameId: gameId },
                }"
                v-for="(item, index) in menus"
                :key="index"
                v-if="item.meta.routers == 1"
              >
                <a-menu-item :key="item.meta.id">{{
                  $t("router." + [item.meta.title])
                }}</a-menu-item>
              </router-link>

              <a-sub-menu key="sub1">
                <span slot="title">
                  <span>{{ $t("router.Exploit_settings") }}</span>
                </span>
                <router-link
                  tag="span"
                  :to="{
                    path: item.path,
                    query: { appId: appId, gameId: gameId },
                  }"
                  v-for="(item, index) in menus"
                  :key="index"
                  v-if="item.meta.routers == 2"
                >
                  <a-menu-item :key="item.meta.id">{{
                    $t("router." + [item.meta.title])
                  }}</a-menu-item>
                </router-link>
              </a-sub-menu>
            </a-menu>
          </div>
        </div>
      </div>

      <div class="info_sub">
        <div class="game_top" v-if="baseInfo != ''">
          <div class="game_url">
            <img
              class="game_img"
              v-if="baseInfo.iconpath"
              :src="baseInfo.iconpath"
              alt=""
            />
            <img class="game_img" v-else src="@/img/no_img.jpg" alt="" />
          </div>
          <div class="game_info">
            <div class="game_info_text">{{ baseInfo.appName }}</div>
            <div class="game_info_text">
              {{ $t("gameinfo.createtime") }}：{{ baseInfo.createTime }}
            </div>
            <div class="game_info_text">
              {{ $t("gameinfo.gamestate") }}：{{ state[baseInfo.state + 1] }}
            </div>
          </div>
        </div>
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      id: this.$route.query.id,
      appId: this.$route.query.appId,
      selectedkeys: this.$route.meta.id,
      gameId: this.$route.query.gameId,
      versions: "",
      state: this.$t("gameinfo.state"),
      selects: 1,
    };
  },
  created() {},
  methods: {
    ...mapActions("user", ["tipMessage"]),
    ...mapActions("game", ["AppInfo"]),

    load() {
      this.AppInfo({
        $axios: this.$axios,
        id: this.id,
      });
    },
  },

  watch: {
    $route(to, from) {
      return (this.selectedkeys = to.meta.id);
    },
  },
  computed: {
    ...mapState("game", ["GameAppInfo", "baseInfo"]),
    menus() {
      return this.$router.options.routes[0].children[2].children;
    },
  },
};
</script>

<style scoped="scoped">
.game_Progress_box {
  width: 1060px;
  position: relative;
  margin: 50px auto;
  display: flex;
  justify-content: space-between;
}
.game_Progress {
  width: 860px;
  height: 2px;
  position: absolute;
  top: 5px;
  left: 100px;
  background-color: #dddddd;
}
.game_Progress_wid {
  width: 432px;
  height: 2px;
  background-color: #4990fa;
}
.game_Progress_wid2 {
  height: 2px;
  background-color: #4990fa;
  width: 717px;
}
.game_Progress_wid3 {
  height: 2px;
  background-color: #4990fa;
  width: 100%;
}

.game_Progress_centent {
  position: relative;
  z-index: 10;
  height: 55px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 200px;
}
.game_Progress_sum {
  width: 18px;
  height: 18px;
  background-color: #dddddd;
  border-radius: 50%;
  font-size: 12px;
  color: #ffffff;
  text-align: center;
  line-height: 18px;
}
.game_Progress_sum_active .game_Progress_sum {
  background-color: #4990fa;
}
.game_Progress_sum_active .game_Progress_text {
  color: #666666;
}
.game_Progress_text {
  /* width: 100px; */
  margin-top: 14px;
  font-size: 14px;
  color: #aaaaaa;
}
.info_box {
  width: 1160px;
  /* height: 720px; */
  background-color: #ffffff;
  box-shadow: 0px 2px 30px 0px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  margin: 40px auto 0;
  display: flex;
  margin-bottom: 105px;
}
.nav {
  width: 165px;
  background-color: #f3f3f3;
}
.nav_text {
  width: 165px;
  height: 52px;
  /* text-align: center; */
  padding-left: 34px;
  line-height: 52px;
}
.nav_text_active {
  box-sizing: border-box;

  border-left: 4px solid #4990fa;
  padding-left: 30px;
  background-color: #ffffff;
}
.info_sub {
  width: 1004px;
  height: 100%;
  padding-bottom: 94px;
}
.game_top {
  display: flex;
  padding: 40px 0 70px 50px;
}
.game_url {
  width: 90px;
  height: 90px;
}
.game_img {
  width: 90px;
  height: 90px;
}
.game_info {
  margin-top: 5px;
  margin-left: 30px;
  font-size: 14px;
  color: #666666;
}
.game_info_text {
  line-height: 14px;
  margin-bottom: 16px;
}
.game_info .game_info_text:nth-last-of-type(1) {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/games/GameInfo.vue